import React, { useState, useEffect, useContext } from 'react';
import Axios from 'axios';

import { BackDropLoad } from './LoadingBackDrop';
import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import {
  AccountHeader,
  FormCard,
  SelectField,
  PrimaryButton,
  Icon,
} from './myacc/primitives';

export const RequestCategoryChange = () => {
  const [loading, setLoading] = useState(true);
  const { user } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  const [cats, setCats] = useState();
  const [subcats, setSubcats] = useState();

  const [cat, setCat] = useState('0');
  const [subcat, setSubcat] = useState('0');

  const [wait, setWait] = useState(false);
  const [error, setError] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
    Axios.get('/new_apis/getsignupdata', {
      headers: { key: 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#' },
    }).then((res) => {
      if (res.data.status === 1) {
        setCats(res.data.cats);
        setSubcats(res.data.subcats);
        setLoading(false);
      }
    });
  }, []);

  const submit = (e) => {
    e.preventDefault();
    setError(0);
    if (cat === '0') {
      setError(1);
      setSnack({ message: 'Please select your category.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if ((cat === '6' || cat === '7') && subcat === '0') {
      setError(2);
      setSnack({ message: 'Please select your sub-category.', type: 'error', open: true, direction: 'center' });
      return;
    }
    setWait(true);
    const formData = { user_id: user.user_id, cat, subcat };
    Axios.post('/new_apis/request_category_change', formData, { headers: { tkn: user.token } }).then((res) => {
      setWait(false);
      if (res.data.status === 1) {
        setSnack({ message: res.data.msg, type: 'success', open: true, direction: 'left' });
      } else if (res.data.status === 2) {
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'center' });
      }
    });
  };

  if (loading) return <Loading />;

  const showSubcat = cat === '7' || cat === '6';

  return (
    <>
      <BackDropLoad wait={wait} />
      <AccountHeader
        kicker="Account"
        title="Request category change"
        subtitle="Ask our team to move your profile to a different category."
      />

      <FormCard onSubmit={submit}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <SelectField
            label="Category"
            value={cat}
            onChange={(e) => { setCat(e.target.value); setSubcat('0'); }}
            error={error === 1}
            errorMsg="Please choose a category."
            required
          >
            <option value="0">Please select a category</option>
            {cats && cats.map((c) => (
              <option key={c.category_id} value={c.category_id}>{c.category_name}</option>
            ))}
          </SelectField>

          {showSubcat && (
            <SelectField
              label="Sub-category"
              value={subcat}
              onChange={(e) => setSubcat(e.target.value)}
              error={error === 2}
              errorMsg="Please choose a sub-category."
              required
            >
              <option value="0">Please select a sub-category</option>
              {subcats && subcats.map((sc) => (cat === sc.category_ids ? (
                <option key={sc.sub_category_id} value={sc.sub_category_id}>{sc.sub_category_name}</option>
              ) : null))}
            </SelectField>
          )}

          <div className="sm:col-span-2 pt-1">
            <PrimaryButton type="submit" loading={wait} icon={<Icon.ArrowRight className="h-4 w-4" />}>
              {wait ? 'Please wait…' : 'Submit request'}
            </PrimaryButton>
          </div>
        </div>
      </FormCard>
    </>
  );
};
